import axiosInstance from "../../Lib/axios";
import {
  GET_FIELD_STAFFF_LIST,
  GET_FIELD_STAFFF_LIST_FAILED,
  GET_SERVICE_ALLOCATION_COMMERCIAL_FAILED,
  GET_SERVICE_ALLOCATION_COMMERCIAL_LIST,
  GET_SERVICE_ALLOCATION_INTIAL_FAILED,
  GET_SERVICE_ALLOCATION_INTIAL_LIST,
  GET_SERVICE_ALLOCATION_RESIDENTAIL_FAILED,
  GET_SERVICE_ALLOCATION_RESIDENTAIL_LIST,
  UPDATE_FIELD_STAFFF,
  UPDATE_FIELD_STAFFF_FAILED,
  GET_SERVICE_ALLOCATION_INSTALL_LIST,
  GET_SERVICE_ALLOCATION_INSTALL_FAILED,
  GET_SERVICE_WEEKLY_ALLOCATION,
  RESET_SERVICE_WEEKLY_ALLOCATION,
  GET_SERVICE_WEEKLY_ALLOCATION_FAILED,
  CANCEL_SERVICE_WEEKLY_ALLOCATION,
  CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED,
  ADD_BLOCKDAY_SUCCESSFULLY,
  ADD_BLOCKDAY_FAILED,
  GET_BLOCKDAY_SUCCESSFULLY,
  GET_BLOCKDAY_FAILED,
  GET_WEEKLY_AVG_SUCCESSFULLY,
  GET_WEEKLY_AVG_FAILED,
  GET_SINGLE_SERVICE_ORDER_SUCCESSFULLY,
  GET_SINGLE_SERVICE_ORDER_FAILED,
  GET_SERVICE_STATISTICS_SUCCESSFULLY,
  GET_SERVICE_STATISTICS_FAILED,
  RETURN_OPTIMIZATION_SUCCESSFULLY,
  RETURN_OPTIMIZATION_FAILED,
  UPDATE_FIELD_SERVICE_SUCCESSFULLY,
  UPDATE_FIELD_SERVICE_FAILED,
  SAVE_FIELD_SERVICE_SUCCESSFULLY,
  SAVE_FIELD_SERVICE_FAILED,
  GET_FIELD_SERVICES_SUCCESSFULLY,
  GET_FIELD_SERVICES_FAILED,
  GET_FIELD_STAFFF_LIST_BY_ID_SUCCESSFULLY,
  GET_FIELD_STAFFF_LIST_BY_ID_FAILED,
  GET_SERVICE_REASONS_SUCCESSFULLY,
  GET_SERVICE_REASONS_FAILED,
  GET_SERVICE_EOD_REPORT_SUCCESSFULLY,
  GET_SERVICE_EOD_REPORT_FAILED,
  RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY,
  RESCHEDULE_MULTIPLE_SERVICES_FAILED,
  GET_SERVICE_ROUTE_CSV_DOWNLOAD_SUCCESSFULLY,
  GET_SERVICE_ROUTE_CSV_DOWNLOAD_FAILED,
  GET_SERVICE_ROUTE_PDF_DOWNLOAD_SUCCESSFULLY,
  GET_SERVICE_ROUTE_PDF_DOWNLOAD_FAILED,
  GET_SERVICE_LIST_SUCCESSFULLY,
  GET_SERVICE_LIST_FAILED,
  GET_CUSTOMER_SERVICE_LIST_SUCCESSFULLY,
  GET_CUSTOMER_SERVICE_LIST_FAILED,
  LOCK_SERVICE_SUCCESSFULLY,
  LOCK_SERVICE_FAILED,
  GET_SCHEDULING_ERRORS_LIST,
  GET_SCHEDULING_ERRORS_LIST_FAILED,
  GET_VIEW_BY_WORK_ORDER_LIST,
  GET_VIEW_BY_WORK_ORDER_LIST_FAILED
} from "../types";

// get user of detail
export const getViewByWorkOrder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-ftech/`, { params })
      .then((response) => {
        dispatch({
          type: GET_VIEW_BY_WORK_ORDER_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_VIEW_BY_WORK_ORDER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get user of detail
export const getFieldOfficeStaff = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/field-technicians/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_STAFFF_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_STAFFF_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Skill Set
export const updateFieldStaff = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/ftech/field-technicians/${params.uuid}/`, { ...params })
      .then((response) => {
        dispatch({
          type: UPDATE_FIELD_STAFFF,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FIELD_STAFFF_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Service Allocation
export const getServiceAllocationIntialClean = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ALLOCATION_INTIAL_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ALLOCATION_INTIAL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Residentail Service Allocation
export const getServiceAllocationResidentail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ALLOCATION_RESIDENTAIL_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ALLOCATION_RESIDENTAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Commercial Service Allocation
export const getServiceAllocationCommercail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ALLOCATION_COMMERCIAL_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ALLOCATION_COMMERCIAL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Install Service Allocation
export const getServiceAllocationInstall = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_ALLOCATION_INSTALL_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ALLOCATION_INSTALL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Weekly Allocation
export const getWeeklyAllocation = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/weekly_allocation/`, { ...params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_WEEKLY_ALLOCATION,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_WEEKLY_ALLOCATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Reset Weekly Allocation
export const resetWeeklyAllocation = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_SERVICE_WEEKLY_ALLOCATION,
      data: '',
    });
  };
};


//Cancel Weekly Services
export const cancelWeeklyAllocation = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/`, { ...params })
      .then((response) => {
        dispatch({
          type: CANCEL_SERVICE_WEEKLY_ALLOCATION,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Add Block Day
export const addBlockDayList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`ftech/week-list/`, { ...params })
      .then((response) => {
        dispatch({
          type: ADD_BLOCKDAY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_BLOCKDAY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Block Day
export const getBlockDayList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/week-list/`, { params })
      .then((response) => {
        dispatch({
          type: GET_BLOCKDAY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_BLOCKDAY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Weekly AVG Data
export const getWeeklyAvgData = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/weekly-avg-data`, { params })
      .then((response) => {
        dispatch({
          type: GET_WEEKLY_AVG_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_WEEKLY_AVG_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Service order
export const getSingleServiceOrder = (uuid,params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/${uuid}`, {params})
      .then((response) => {
        dispatch({
          type: GET_SINGLE_SERVICE_ORDER_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SINGLE_SERVICE_ORDER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Service statistics
export const getServiceStatistics = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/service-allocation/service_stats/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_STATISTICS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_STATISTICS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Cancel Weekly Services
export const cancelAndRescheduleWeeklyAllocation = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/`, [ ...params ])
      .then((response) => {
        dispatch({
          type: CANCEL_SERVICE_WEEKLY_ALLOCATION,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Rerun optimization
export const rerurnOptimization = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/re_run_optimization/`, { ...params })
      .then((response) => {
        dispatch({
          type: RETURN_OPTIMIZATION_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RETURN_OPTIMIZATION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update Field services
export const updateFieldService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/ftech/service-allocation/${params.uuid}/`, { ...params })
      .then((response) => {
        dispatch({
          type: UPDATE_FIELD_SERVICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FIELD_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get field services
export const getFieldServices = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`ftech/services/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_SERVICES_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_SERVICES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Save field service
export const saveFieldService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/`, { ...params })
      .then((response) => {
        dispatch({
          type: SAVE_FIELD_SERVICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SAVE_FIELD_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


export const getFieldOfficeStaffById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/field-technicians/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_STAFFF_LIST_BY_ID_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_STAFFF_LIST_BY_ID_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Service Reason
export const getServiceReasons = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/reasons/`, {params})
      .then((response) => {
        dispatch({
          type : GET_SERVICE_REASONS_SUCCESSFULLY,
          data : response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_REASONS_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
};

//Service EOD Report

export const getServiceEODReport = ( params, filename ) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/service-eod-report/`, {params} )
      .then((response) => {
        if(params.format) {
          let data = response.data;
          var blob = new Blob([data], { type: "application/CSV" });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          dispatch({
            type : GET_SERVICE_EOD_REPORT_SUCCESSFULLY,
            data : response.data,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_EOD_REPORT_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

export const rescheduleMultipleServices = ( params ) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-allocation/`, params )
      .then((response) => {
        dispatch({
          type: RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RESCHEDULE_MULTIPLE_SERVICES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const getServiceRouteCSVFormat = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/technician-route/`, {params} )
      .then((response) => {
        // let data = response.data;
        // var blob = new Blob([data], { type: "application/CSV" });
        // var link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = "services.csv";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        dispatch({
          type: GET_SERVICE_ROUTE_CSV_DOWNLOAD_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ROUTE_CSV_DOWNLOAD_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

export const getServiceRoutePDFFormat = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`ftech/technician-route/export_routes/`, {params} )
      .then((response) => {
        // let data = response.data;
        // var blob = new Blob([data], { type: "application/pdf" });
        // var link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = "services.pdf";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        dispatch({
          type: GET_SERVICE_ROUTE_PDF_DOWNLOAD_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_ROUTE_PDF_DOWNLOAD_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

//Get Service Listing
export const getServiceList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-addon/`, {params})
      .then((response) => {
        dispatch({
          type : GET_SERVICE_LIST_SUCCESSFULLY,
          data : response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

//Get Customer Listing in field tech
export const getCustomerServiceList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/customer-list/`, {params})
      .then((response) => {
        dispatch({
          type : GET_CUSTOMER_SERVICE_LIST_SUCCESSFULLY,
          data : response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CUSTOMER_SERVICE_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

//Add New Service in Field Tech

export const addNewService = ( params ) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/ftech/service-create/`, params )
      .then((response) => {
        dispatch({
          type: RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RESCHEDULE_MULTIPLE_SERVICES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

//Lock Service
export const lockService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/ftech/service-allocation/lock_service/`, params)
      .then((response) => {
        dispatch({
          type: LOCK_SERVICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: LOCK_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}


//Get Scheduling errors list
export const getSchedulingErrorsList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/ftech/optimo-errors/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SCHEDULING_ERRORS_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SCHEDULING_ERRORS_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}
